export default "__VITE_ASSET__ekKnNyFE__"